import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b703e67f: FaireBrandEntity = {
  token: "b_b703e67f",
  type: "brand",
  name: "A Shop of Things",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/9a01d8ce0ab02880f30c6f5001d346e48af94055e98cfbf8d02558fb719d6181/1565984578.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/644276a762e9932dc9d0fb57d4454db7aa0409e63a2dd270e14b1dc694433735.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/9a01d8ce0ab02880f30c6f5001d346e48af94055e98cfbf8d02558fb719d6181/1565984578.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/644276a762e9932dc9d0fb57d4454db7aa0409e63a2dd270e14b1dc694433735.jpeg",
  location: "Nashville, TN, USA",
  minimumOrderDollars: 208,
  rating: 4.9,
  reviewCount: 212,
  isTopShop: true,
  isInsider: true,
  description:
    "A Shop of Things is a curated online store of objects for the modern adult. Edgy and sassy, empowering and adorable, our goal is to take your every day household item and make it cuter!\n♥️\nIf you'd like to know more, give us a shout, collaborate, invite us to a fun event, or for wholesale info, send us a message:  [redacted-email]\n♥️\nFollow ASOT on Instagram for the latest and greatest updates\n♥️",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:20.009Z",
    importedBy: "entity-db-cli",
  },
};
